import axios from 'axios'
import { buildQuery } from '../exports/queryStringBuilder'

export default {
    async create(model) {
        return await axios.post(`order-report`, model)
    },
    async fetchById(id) {
        return await axios.get(`order-report/${id}`)
    },
    async fetch(query, page) {
        return await axios.get(`order-report?q=${query}&page=${page}`)
    },
    async fetchDrivers() {
        return await axios.get(`user`)
    },
  
    async update(id, model) {
        return await axios.put(`order-report/${id}`, model)
    },
    async delete(id) {
        return await axios.delete(`order-report/${id}`)
    },

    async export_report(id, filters) {
        return await axios.post(`order-report/export-report/${id}`, filters)
    },

    async fetchTableColumnsData(options) {
        // options = options.join(',')
        return await axios.get(`order-report/fetch-table-columns?options=${options}`)
    },
}
